import Vue from 'vue'
import Vuex from 'vuex'
const axios = require('axios')
const tinycolor = require('tinycolor2')
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        hash: null,
        norm: 85,
        currentBatch: null,
        screenData: {},
        defects: [],
        defectHeartbeat: {
            labels: [
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0
            ],
            datasets: []
        }
    },
    mutations: {
        setHash: (state, payload) => {
            state.hash = payload
        },
        setBatch: (state, payload) => {
            if (payload) {
                state.currentBatch = payload[0]
            } else {
                state.currentBatch = payload
            }
        },
        setScreenData: (state, payload) => {
            state.screenData = payload

        },
        setDefects: (state, payload) => {
            state.defects = payload
            var defectDataArray = []
            var colors = tinycolor('#1764ff').analogous(state.defects.length)

            payload.forEach((defect, idx) => {
                defectDataArray.push({
                    lineTension: 0,
                    label: defect.name,
                    borderColor: colors[idx],
                    // backgroundColor: 'rgba(0,0,0,0)', //tinycolor(colors[idx]).setAlpha(0.1).toRgbString(),
                    backgroundColor: colors[idx].setAlpha(.6).toRgbString(),
                    id: defect.id,
                    data: [0]
                })
            })
            defectDataArray.push({
                lineTension: 0,
                label: "yield",
                borderColor: tinycolor("#119b48").setAlpha(1).toRgbString(),
                backgroundColor: tinycolor("#119b48").setAlpha(.9).toRgbString(),
                data: [100]
            })
            state.defectHeartbeat.datasets = defectDataArray

        },
        updateChartData: (state, payload) => {
            state.defectHeartbeat.labels = new Array(Math.round(parseInt(state.currentBatch.batchSize) * 1.5)).fill(0)
            state.defectHeartbeat.datasets[payload.idx].data.push(payload.value)
        }
    },
    getters: {
        getBatch: (state) => {
            return state.currentBatch
        },
        getNormValue: (state) => {
            return state.norm
        },
        getTotalFromBatch: (state) => {

            let total = 0;
            let percentage = 0;
            let materialDefect = 0
            if (!state.currentBatch) {
                return {total, percentage}
            }

            if (state.currentBatch.defects) {
                state.currentBatch.defects.forEach((def) => {
                    if (def.defect_id !== 16) {
                        total += def.value
                    } else {
                        materialDefect += def.value
                    }
                })
            }


            var totalProcessed = total + state.currentBatch.redo + state.currentBatch.approved  + materialDefect

            if (total == 0 && state.currentBatch.approved == 0) {
            } else {

                percentage = parseInt(((state.currentBatch.approved + state.currentBatch.redo  + materialDefect) / totalProcessed) * 100)

            }

            return {total: parseInt(totalProcessed), percentage}

        },
        getWeekPercentage: (state) => {
            var backGroundcolor = ['#186199', '#cccccc']
            if (state.screenData.weekPercentage >= state.norm) {
                backGroundcolor = ['#186199', '#cccccc']
            } else {
                backGroundcolor = ['#186199', '#cccccc']
            }
            return {
                dataset: {
                    labels: ['ftr'],
                    datasets: [
                        {
                            borderAlign: 'center',
                            backgroundColor: backGroundcolor,
                            data: [state.screenData.weekPercentage, (state.screenData.weekPercentage - 100)]
                        }
                    ]
                }, value: state.screenData.weekPercentage
            }
        },
        getMonthPercentage: (state) => {
            var backGroundcolor = ['#186199', '#cccccc']
            if (state.screenData.monthPercentage >= state.norm) {
                backGroundcolor = ['#186199', '#cccccc']
            } else {
                backGroundcolor = ['#186199', '#cccccc']
            }
            return {
                dataset: {
                    labels: ['ftr'],
                    datasets: [
                        {
                            borderAlign: 'center',
                            backgroundColor: backGroundcolor,
                            data: [state.screenData.monthPercentage, (state.screenData.monthPercentage - 100)]
                        }
                    ]

                }, value: state.screenData.monthPercentage
            }
        },
        getTopDefects: (state) => {
            return state.screenData.topDefects
        },
        getHeartBeatData: (state) => {
            return state.defectHeartbeat
        },
        getApiDefects: (state) => {
            return state.defects
        }
    },
    actions: {
        getScreenData: ({state, commit, dispatch}) => {
         axios.get('https://europe-west1-perfect-coat-defects.cloudfunctions.net/http_http/dashboardStats/stats?hash=0e428725ebcac4f66ba051c4def648d5').then(res=>{

             if (res.status === 200) {
                 res.data.monthPercentage = parseInt(parseInt(res.data.monthPercentage).toFixed(0))
                 res.data.weekPercentage = parseInt(parseInt(res.data.weekPercentage).toFixed(0))
                 commit('setScreenData', res.data)
             }
         })
            // DATA_API.get('/dashboard/screen').then(res => {
            //     if (res.status === 200) {
            //         res.data.monthPercentage = parseInt(parseInt(res.data.monthPercentage).toFixed(0))
            //         res.data.weekPercentage = parseInt(parseInt(res.data.weekPercentage).toFixed(0))
            //         commit('setScreenData', res.data)
            //     }
            // })
        },
        updateDefects: ({state, commit, getters}) => {

            var totalDefects = 0;
            var totalDefectPercentage = 0
            state.defectHeartbeat.datasets.forEach((defectHeartbeat, idx) => {
                _.find(state.currentBatch.defects, function (def) {

                    if (def.defect_id === defectHeartbeat.id && def.defect_id !== 16) {
                      totalDefectPercentage+= (parseInt(def.value / parseInt(getters.getTotalFromBatch.total) * 100))
                        totalDefects += def.value
                        commit('updateChartData', {
                            idx,
                            value: parseInt(def.value / parseInt(getters.getTotalFromBatch.total) * 100)
                        })
                    }

                });

            })

            commit('updateChartData', {
                idx: (state.defectHeartbeat.datasets.length -1) ,
                value: 100 - totalDefectPercentage
            })


        },
        getHeartBeatData() {

        }

    },

})
